import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import Link from 'react-router-dom/Link';
import {connect} from 'react-redux';
import {getSchoolsTypes, getSchoolsProgrammes, getSchoolsDegrees, getSchools, toggleDrawerMobileFilterSearch, setSchoolsSearchCriteria} from '../../actions';
import {getSidebarContent} from "../../../Content/actions";
import Button from '@material-ui/core/Button';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import {withLocalize, Translate} from 'react-localize-redux';
import translations from '../../translations/translations_schools_list';
import translationsSearchbar from '../../translations/translations_schoolssearchbar';
import ReactHtmlParser from 'react-html-parser';
import IconFilter from "../../assets/img/icon-filter.svg";
import Drawer from '@material-ui/core/Drawer';
import CloseIcon from '@material-ui/icons/Close';
import classnames from 'classnames';
import {Helmet} from "react-helmet";

class SchoolsSearch extends Component {
    formRef = React.createRef();

    state = {
        type: this.props.search.type,
        programme: this.props.search.programme,
        degree: this.props.search.degree,
        userClick: false,
        populateFromSearch: false,
        searchFormSticky: false,
        searchFormStickyWidth: 0,
    };

    constructor(props) {
        super(props);

        this.props.addTranslation(translations);
        this.props.addTranslation(translationsSearchbar);
    }

    fetchContent() {
        const {taxonomiesLoading, sidebarLoading} = this.props;

        // Get the taxonomies terms
        if (!taxonomiesLoading) {
            this.props.getSchoolsTypes();
            this.props.getSchoolsProgrammes();
            this.props.getSchoolsDegrees();
        }

        // Get the widgets
        if (!sidebarLoading) {
            this.props.getSidebarContent('agep_schools');
        }
    }

    componentDidMount() {
        this.handlePageScroll();
        window.addEventListener('scroll', this.handlePageScroll);
        window.addEventListener('resize', this.handlePageScrollResize);

        this.fetchContent();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.languages !== this.props.languages) {
            this.fetchContent();
        }

        if (this.state.type !== prevState.type || this.state.programme !== prevState.programme || this.state.degree !== prevState.degree) {
            if (this.state.userClick) {
                // Only trigger a search when the user itself change the search criteria...
                this.props.getSchools(
                    1, // No offset
                    false, // Page with previous results
                    true, // Reset the search results / listing
                    this.state.type,
                    this.state.programme,
                    this.state.degree
                );

                this.props.setSchoolsSearchCriteria(
                    this.state.type,
                    this.state.programme,
                    this.state.degree
                );

                if (this.props.drawerMobileFilterSearchOpen) {
                    this.props.toggleDrawerMobileFilterSearch();
                }
            }
        }
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handlePageScroll);
        window.removeEventListener('resize', this.handlePageScrollResize);
    }

    handleChange = e => {
        // NB: setState is asynchronous!
        // If we call the getSchools function here, it'll be triggered before the state changed.
        // We'll use componentDidUpdate() => called after the state has changed

        this.setState({
            [e.target.name]: e.target.value,
            'userClick' : true,
        });
    };

    toggleFilterDrawer = (open) => () => {
        this.props.toggleDrawerMobileFilterSearch();
    };

    handlePageScroll = () => {
        if (!this.formRef.current) {
            return false;
        }

        let width = this.state.searchFormStickyWidth;

        if (this.state.searchFormStickyWidth === 0) {
            width = this.formRef.current.offsetWidth;
        }

        const currentScroll = window.scrollY;

        let isSticky = false;

        if (currentScroll > 0) {
            let offset = document.getElementById('form-container').offsetTop + document.getElementById('site-header').offsetTop - 30;

            if (currentScroll >= offset) {
                isSticky = true;
            }
        }

        this.setState({
            searchFormSticky: isSticky,
            searchFormStickyWidth: width,
        });
    };

    handlePageScrollResize = () => {
        if (!this.formRef.current) {
            return false;
        }

        const width = document.getElementById('form-container').offsetWidth;

        this.setState({
            searchFormStickyWidth: width,
        });
    };

    render() {
        const {sidebar, sidebarLoading, loading, schools, totalFuture} = this.props;
        const {types, programmes, degrees, taxonomiesLoading} = this.props;
        const {drawerMobileFilterSearchOpen} = this.props;

        let menuItemsTypes = [];
        let menuItemsProgrammes = [];
        let menuItemsDegrees = [];

        if (types !== null && !taxonomiesLoading) {
            types.map(term => (
                menuItemsTypes.push(<MenuItem value={term.term_id} key={term.term_id}><div className="menu-item-content">{term.name}</div></MenuItem>)
            ));
        }

        if (programmes !== null && !taxonomiesLoading) {
            programmes.map(term => (
                menuItemsProgrammes.push(<MenuItem value={term.term_id} key={term.term_id}><div className="menu-item-content">{term.name}</div></MenuItem>)
            ));
        }

        if (degrees !== null && !taxonomiesLoading) {
            degrees.map(term => (
                menuItemsDegrees.push(<MenuItem value={term.term_id} key={term.term_id}><div className="menu-item-content">{term.name}</div></MenuItem>)
            ));
        }

        let sectionTitle = '';
        let widgets = null;

        if (sidebar === undefined || sidebar.agep_schools === null || sidebar.agep_schools === undefined || sidebarLoading) {
            sectionTitle = <span className="placeholder-line"></span>;
        } else {
            widgets = sidebar.agep_schools.widgets;
            sectionTitle = ReactHtmlParser(widgets.titre.data.content);
        }

        return (
            <Fragment>
                {typeof this.state.searchFormStickyWidth === "number" && this.state.searchFormStickyWidth > 0 &&
                    <Helmet>
                        <style type="text/css">{`
                            section#schools-search form { width: ` + this.state.searchFormStickyWidth + `px; }
                        `}</style>
                    </Helmet>
                }
                <section id="schools-search">
                    <div className="row">
                        <div className="col col-6 col-lg-12">
                            <Button size="medium" className="btnBack" component={props => <Link to="/" {...props}/>}>
                                <KeyboardBackspaceIcon className="btnIcon" />
                                <Translate id="schools_list.button_back" />
                            </Button>
                        </div>
                        <div className="col col-6 d-lg-none">
                            <div className="float-right">
                                <Button size="medium" className="btn-filter m-auto d-flex d-lg-none justify-content-center" variant="contained" color="primary" onClick={this.toggleFilterDrawer(true)}>
                                    <object data={IconFilter} type="image/svg+xml">
                                        <i className="material-icons">filter</i>
                                    </object>
                                    <Translate id="schools_list.button_filter" />
                                </Button>
                            </div>
                        </div>
                    </div>

                    <div className="row row-title">
                        <div className="col col-12">
                            <h1>{sectionTitle} {(!loading && Array.isArray(schools) && schools.length > 0 && totalFuture !== '') && <span className="count">({totalFuture} <Translate id="schools_list.request_count" />)</span>}</h1>
                        </div>
                    </div>

                    <div className="form-container d-none d-lg-block" id="form-container">
                        <form autoComplete="off" ref={this.formRef} className={classnames('d-none d-lg-block', {
                            'sticky': this.state.searchFormSticky,
                        })}>
                            <div className="row">
                                <div className="col col-4">
                                    <FormControl fullWidth={true}>
                                        <InputLabel htmlFor="school-type">
                                            <Translate id="schools_search_bar.type_ecole" />
                                        </InputLabel>
                                        <Select
                                            className="select-dropdown"
                                            value={this.state.type}
                                            onChange={this.handleChange}
                                            inputProps={{
                                                name: 'type',
                                                id: 'school-type',
                                            }}
                                        >
                                            <MenuItem value={0}>
                                                <em><Translate id="schools_search_bar.item_all" /></em>
                                            </MenuItem>
                                            {menuItemsTypes}
                                        </Select>
                                    </FormControl>
                                </div>
                                <div className="col col-4">
                                    <FormControl fullWidth={true}>
                                        <InputLabel htmlFor="school-programme">
                                            <Translate id="schools_search_bar.programme" />
                                        </InputLabel>
                                        <Select
                                            value={this.state.programme}
                                            onChange={this.handleChange}
                                            inputProps={{
                                                name: 'programme',
                                                id: 'school-programme',
                                            }}
                                        >
                                            <MenuItem value={0}>
                                                <em><Translate id="schools_search_bar.item_all" /></em>
                                            </MenuItem>
                                            {menuItemsProgrammes}
                                        </Select>
                                    </FormControl>
                                </div>
                                <div className="col col-4">
                                    <FormControl fullWidth={true}>
                                        <InputLabel htmlFor="school-degree">
                                            <Translate id="schools_search_bar.diplome" />
                                        </InputLabel>
                                        <Select
                                            value={this.state.degree}
                                            onChange={this.handleChange}
                                            inputProps={{
                                                name: 'degree',
                                                id: 'school-degree',
                                            }}
                                        >
                                            <MenuItem value={0}>
                                                <em><Translate id="schools_search_bar.item_all" /></em>
                                            </MenuItem>
                                            {menuItemsDegrees}
                                        </Select>
                                    </FormControl>
                                </div>
                            </div>
                        </form>
                    </div>
                </section>

                <Drawer id="filter-drawer" anchor="right" open={drawerMobileFilterSearchOpen} onClose={this.toggleFilterDrawer(false)} className="header-drawer" classes={{
                    paper: 'header-drawer-paper almost-full',
                }}>
                    <div className="wrapper wrapper-top">
                        <div className="inner">
                            <div className="drawer-title">
                                <span className="section">{sectionTitle}</span>
                                <h2 className="title"><Translate id="schools_list.button_filter" /></h2>
                                <Button size="large" className="btn-close-drawer" onClick={this.toggleFilterDrawer(false)}>
                                    <CloseIcon className="m-icon" />
                                </Button>
                            </div>
                        </div>
                    </div>
                    <div className="wrapper wrapper-bottom">
                        <div className="inner">
                            <form autoComplete="off">
                                <div className="row row-search">
                                    <div className="col col-12 mb-20">
                                        <FormControl fullWidth={true}>
                                            <InputLabel htmlFor="school-type">
                                                <Translate id="schools_search_bar.type_ecole" />
                                            </InputLabel>
                                            <Select
                                                value={this.state.type}
                                                onChange={this.handleChange}
                                                inputProps={{
                                                    name: 'type',
                                                    id: 'school-type',
                                                }}
                                            >
                                                <MenuItem value="">
                                                    <em><Translate id="schools_search_bar.item_all" /></em>
                                                </MenuItem>
                                                {menuItemsTypes}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div className="col col-12 mb-20">
                                        <FormControl fullWidth={true}>
                                            <InputLabel htmlFor="school-programme">
                                                <Translate id="schools_search_bar.programme" />
                                            </InputLabel>
                                            <Select
                                                value={this.state.programme}
                                                onChange={this.handleChange}
                                                inputProps={{
                                                    name: 'programme',
                                                    id: 'school-programme',
                                                }}
                                            >
                                                <MenuItem value="">
                                                    <em><Translate id="schools_search_bar.item_all" /></em>
                                                </MenuItem>
                                                {menuItemsProgrammes}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div className="col col-12 mb-20">
                                        <FormControl fullWidth={true}>
                                            <InputLabel htmlFor="school-degree">
                                                <Translate id="schools_search_bar.diplome" />
                                            </InputLabel>
                                            <Select
                                                value={this.state.degree}
                                                onChange={this.handleChange}
                                                inputProps={{
                                                    name: 'degree',
                                                    id: 'school-degree',
                                                }}
                                            >
                                                <MenuItem value="">
                                                    <em><Translate id="schools_search_bar.item_all" /></em>
                                                </MenuItem>
                                                {menuItemsDegrees}
                                            </Select>
                                        </FormControl>
                                    </div>
                                </div>
                                <div className="row mt-20">
                                    <div className="col col-12">
                                        <Button onClick={this.toggleFilterDrawer(false)} size="medium" variant="contained" color="primary">
                                            <Translate id="schools_list.afficher_resultats" />
                                        </Button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </Drawer>
            </Fragment>
        );
    }
}

SchoolsSearch.propTypes = {
    getSchoolsTypes: PropTypes.func.isRequired,
    getSchoolsProgrammes: PropTypes.func.isRequired,
    getSchoolsDegrees: PropTypes.func.isRequired,
    getSchools: PropTypes.func.isRequired,
    getSidebarContent: PropTypes.func.isRequired,
    toggleDrawerMobileFilterSearch: PropTypes.func.isRequired,
    setSchoolsSearchCriteria: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    types: state.schools.types,
    programmes: state.schools.programmes,
    degrees: state.schools.degrees,
    search: state.schools.search,
    taxonomiesLoading: state.schools.taxonomiesLoading,
    sidebar: state.content.sidebar,
    sidebarLoading: state.content.sidebarLoading,
    drawerMobileFilterSearchOpen: state.schools.drawerMobileFilterSearchOpen,
    loading: state.schools.schoolsLoading,
    schools: state.schools.schools,
    totalFuture: state.schools.totalFuture,
});

export default connect(mapStateToProps, {getSchoolsTypes, getSchoolsProgrammes, getSchoolsDegrees, getSchools, getSidebarContent, toggleDrawerMobileFilterSearch, setSchoolsSearchCriteria})(withLocalize(SchoolsSearch));



// WEBPACK FOOTER //
// ./src/features/Schools/components/List/SchoolsSearch.js